<template>
  <div class="design-elements">
    <h1 class="design-elements__heading">{{ $t("resources.domains.page_elements_title") }}</h1>
    <p class="design-elements__subheading">{{ $t("resources.domains.page_elements_subtitle") }}</p>
    <va-redirect-block
      :route="{
        name: 'headers_list',
        query: { filter: JSON.stringify({ domain: [domainId] }), displayBack: true },
      }"
      :title="$t('resources.domains.page_elements_headers_title')"
      :sub-title="$t('resources.domains.page_elements_headers_subtitle')">
      <img :src="$vuetify.theme.dark ? headerDarkImg : headerLightImg" alt="Header img" />
    </va-redirect-block>
    <va-redirect-block
      :route="{
        name: 'footers_list',
        query: { filter: JSON.stringify({ domain: [domainId] }), displayBack: true },
      }"
      :title="$t('resources.domains.page_elements_footers_title')"
      :sub-title="$t('resources.domains.page_elements_footers_subtitle')">
      <img :src="$vuetify.theme.dark ? footerDarkImg : footerLightImg" alt="Footer img" />
    </va-redirect-block>
  </div>
</template>

<script>
  import VaRedirectBlock from "@/components/custom/VaRedirectBlock";

  import headerLightImg from "@/assets/images/page-elements/header-light.svg";
  import headerDarkImg from "@/assets/images/page-elements/header-dark.svg";
  import footerLightImg from "@/assets/images/page-elements/footer-light.svg";
  import footerDarkImg from "@/assets/images/page-elements/footer-dark.svg";

  export default {
    name: "PageElements",
    components: {
      VaRedirectBlock,
    },
    props: {
      domainId: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        headerLightImg,
        headerDarkImg,
        footerLightImg,
        footerDarkImg,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../../@core/preset/preset/functions.scss";
  @import "../../../@core/preset/preset/typography/index.scss";
  .design-elements {
    &__heading {
      margin-top: 40px;
      margin-bottom: 6px;
      @include heading-3();
      color: get-color("headline");
    }
    &__subheading {
      @include text-subtitle-1();
      color: get-color("subtitle");
      margin-bottom: 24px;
    }

    .redirect-block {
      margin-bottom: 24px;
    }
  }
</style>
